import React from 'react';
import ContactUsButton from '../components/ContactUsButton';
import PhotoCarousel from '../components/PhotoCarousel';
import { heroImages } from '../data/heroImages';

const WeddingRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Weddings</p>
          <h1 className="page-title">Wedding Events</h1>
          <p className="page-subtitle">
            Guidelines and information for hosting weddings at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Weddings"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>The Space</h2>
            <p className="rules-section-intro">
              The main event hall dressed for a wedding — seating, buffet, stage, and dance floor.
            </p>
            <PhotoCarousel images={heroImages} />
            <p className="rules-section-credit">
              Photos by{' '}
              <a
                href="https://tyrabphotography.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                TyraB Photography
              </a>
              <span aria-hidden="true"> · </span>
              Tables &amp; chairs by{' '}
              <a
                href="https://riversiderentalsfertile.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Riverside Rentals
              </a>
            </p>
          </div>

          <div className="rules-section">
            <h2>Venue Usage</h2>
            <ul>
              <li>Wedding reservations include access to the main event hall and designated preparation areas.</li>
              <li>Setup and teardown times must be included in your reservation window.</li>
              <li>Maximum capacity and layout options will be confirmed during the booking process.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Decorations</h2>
            <ul>
              <li>Decorations must not damage walls, floors, or fixtures (no nails, staples, or permanent adhesives).</li>
              <li>Open flame candles are only allowed in enclosed containers and must be approved in advance.</li>
              <li>Confetti, glitter, and similar materials are not permitted inside the facility.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Catering &amp; Vendors</h2>
            <ul>
              <li>Caterers must provide proof of license and insurance upon request.</li>
              <li>All food service must comply with local health and safety regulations.</li>
              <li>Vendors are responsible for setup, teardown, and removal of their materials.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>General Policies</h2>
            <ul>
              <li>Events must conclude by the agreed-upon end time in the rental agreement.</li>
              <li>Alcohol service must comply with all applicable laws and may require additional approvals.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default WeddingRulesPage;


